import { useState, useEffect } from 'react';
import {
  INITIAL_PAGE_INDEX,
  ITEMS_PER_PAGE,
  VISIBLE_PAGES,
  ROWS_PER_PAGE,
} from '../../constants';

const computeTotalPages = (data: [], size: number) => {
  return Math.ceil(data.length / size);
};

const extractPaginatedData = (data: [], size: number, index: number) => {
  const start = size * index - size;
  const end = size * index;
  return data.slice(start, end);
};

const useSupportHourMobilePagination = (
  assets: [],
  initialPageSize = ITEMS_PER_PAGE
) => {
  const [currentPageSize, setCurrentPageSize] = useState<number>(
    initialPageSize
  );
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(
    INITIAL_PAGE_INDEX
  );
  const [paginatedData, setPaginatedData] = useState<object[]>([]);
  const [totalPageCount, setTotalPageCount] = useState<number>(0);

  useEffect(() => {
    if (assets.length === 0) {
      setCurrentPageIndex(0);
    } else {
      setCurrentPageIndex(INITIAL_PAGE_INDEX);
    }
  }, [assets]);

  useEffect(() => {
    if (assets.length > 0) {
      const slicedData = extractPaginatedData(
        assets,
        currentPageSize,
        currentPageIndex
      );
      const computedTotalPages = computeTotalPages(assets, currentPageSize);

      setTotalPageCount(computedTotalPages);
      setPaginatedData(slicedData);
    } else {
      const slicedData = extractPaginatedData(
        assets,
        currentPageSize,
        currentPageIndex
      );
      const computedTotalPages = computeTotalPages(assets, currentPageSize);

      setPaginatedData(slicedData);
      setTotalPageCount(computedTotalPages);
    }
  }, [assets, currentPageIndex, currentPageSize, paginatedData.length]);

  const onPageChange = (newIndex: number) => {
    setCurrentPageIndex(newIndex);
  };

  const onPageSizeChange = (newSize: number) => {
    const computedTotalPages = computeTotalPages(assets, newSize);

    setCurrentPageSize(newSize);
    setTotalPageCount(computedTotalPages);
    setCurrentPageIndex(INITIAL_PAGE_INDEX);
  };
  return {
    mobileViewPageSize: currentPageSize,
    totalPages: totalPageCount,
    VISIBLE_PAGES,
    ROWS_PER_PAGE,
    mobileViewData: paginatedData,
    handlePageChange: onPageChange,
    handlePageSizeChange: onPageSizeChange,
    totalItems: assets.length,
    pageIndex: currentPageIndex,
  };
};

export default useSupportHourMobilePagination;
